import {RESPONSE_STATUSES, REST_METHODS} from '@/src/app/constants/api';
import unauthorizedFetch from '@/src/app/utils/unauthorizedFetch';

export const getTimerDate = async () => {
  // @ts-ignore
  return unauthorizedFetch({
    method: REST_METHODS.GET,
    path: `/api/v1/marketing/trial-promotion`,
    skiptStatsuses: [RESPONSE_STATUSES.NOT_FOUND],
  });
};
